import _ from 'lodash'
import {useContext} from 'react'
import {FormTextArea} from 'semantic-ui-react'
import {AuthContext} from '@/features/auth'
import {ILabelingWidgetConfig, ILabelingWidgetProps} from '..'
import './style.css'

export interface ITextLabel {
  text: string
}

export type ITextLabelingWidgetProps = ILabelingWidgetProps<ITextLabel>

function LabelingWidget(props: ITextLabelingWidgetProps) {
  const {
    selectedEvent,
    currentLabelData,
    disabled,
    implicitLabelData,
    setCurrentLabelData,
    deleteLabelData,
  } = props

  const {havePermission} = useContext(AuthContext)

  const canAddLabel = havePermission('label.add_label')

  return (
    <div className='labeling-widget text'>
      {selectedEvent.text ?
        <div className='current-value'>{selectedEvent.text}</div>
      : undefined}
      <FormTextArea
        disabled={disabled || !canAddLabel}
        placeholder={implicitLabelData?.text || selectedEvent.text}
        value={currentLabelData?.text}
        onChange={(_e, {value}) => {
          if (value === undefined) deleteLabelData()
          if (_.isString(value)) {
            if (value.length > 0) setCurrentLabelData({text: value})
            else deleteLabelData()
          }
        }}
      />
      {implicitLabelData && !_.isEqual(implicitLabelData.text, currentLabelData?.text) ?
        <div style={{textAlign: 'center'}}>(implicit label: {implicitLabelData.text})</div>
      : null}
    </div>
  )
}

export const labelingWidgetConfigText: ILabelingWidgetConfig<ITextLabel, ITextLabelingWidgetProps> =
  {
    canDelete: true,
    control: LabelingWidget,
  }
